import type React from 'react';
import { HelpCircle } from 'lucide-react';

interface TourHelpButtonProps {
  onClick: () => void;
  className?: string;
  dataTour?: string;
}

const TourHelpButton: React.FC<TourHelpButtonProps> = ({ onClick, className, dataTour }) => {
  return (
    <button
      onClick={onClick}
      className={`p-2.5 rounded-xl text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors ${className ?? ''}`}
      aria-label="Показать обучение"
      title="Показать обучение"
      data-tour={dataTour}
    >
      <HelpCircle className="w-5 h-5" />
    </button>
  );
};

export default TourHelpButton;
